import { StrictMode, createContext, useContext } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../js/api/queryClient";
import { MySavedColorsModal } from "./components/my-saved-colors/my-saved-colors-modal";
import { EditColorCollectionModal } from "./components/color-collections/edit-color-collection-modal";
import { AddToColorCollectionModal } from "./components/color-collections/add-to-color-collection-modal";
import { AddSavedColorsToCollectionModal } from "./components/my-saved-colors/add-saved-colors-to-collection-modal";
import { InviteFriendModal } from "./components/invite-friend/invite-friend-modal";

const MainReactContext = createContext();
export const useMainReact = () => useContext(MainReactContext);
function MainReactProvider({ data, children }) {
  return (
    <MainReactContext.Provider value={data}>
      {children}
    </MainReactContext.Provider>
  );
}

export function MainReactRenderer() {
  const element = document.getElementById("main-react");
  if (!element) return;

  let initialProps = {};
  try {
    initialProps = JSON.parse(element.getAttribute("data-initial-props"));
  } catch (error) {
    console.error(error, "Could not parse initial props JSON for MainReact");
  }
  createRoot(element).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <MainReactProvider data={initialProps}>
          <>
            <EditColorCollectionModal />
            <AddToColorCollectionModal />
            <MySavedColorsModal />
            <AddSavedColorsToCollectionModal />
            <InviteFriendModal />
          </>
        </MainReactProvider>
      </QueryClientProvider>
    </StrictMode>
  );
}

export const initMainReact = () => {
  if (document.readyState !== "loading") {
    MainReactRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", MainReactRenderer);
  }
};
